import type { Step } from "react-joyride";

export const qcRecordDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດບັນທຶກ QC! ຫນ້ານີ້ຈະສະແດງຂໍ້ມູນທັງໝົດຂອງບັນທຶກ QC. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="record-detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນ header. ທ່ານສາມາດກັບໄປຫນ້າລາຍການບັນທຶກ QC ດ້ວຍປຸ່ມ 'ກັບ', ເບິ່ງ PDF Preview ດ້ວຍປຸ່ມ 'ເບິ່ງ PDF Preview', ແກ້ໄຂບັນທຶກ QC ນີ້ດ້ວຍປຸ່ມ 'ແກ້ໄຂ' (ຖ້າທ່ານມີສິດແກ້ໄຂ), ຫຼືລຶບບັນທຶກ QC ນີ້ດ້ວຍປຸ່ມ 'ລຶບ' (ຖ້າທ່ານມີສິດລຶບ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="record-detail-basic-info"]',
    content:
      "ນີ້ແມ່ນຂໍ້ມູນພື້ນຖານຂອງບັນທຶກ QC. ທ່ານຈະເຫັນມາດຕະຖານ QC, ຜູ້ກວດສອບ, ວັນທີກວດສອບ, ສະຖານທີ່, ປະເພດງານ, ລະຫັດງານ, ວັນທີສ້າງ, ວັນທີອັບເດດລ່າສຸດ, ສະຖານະລວມ (ຜ່ານ/ບໍ່ຜ່ານ/ກຳລັງກວດສອບ), ແລະຫມາຍເຫດທົ່ວໄປຂອງບັນທຶກ QC ນີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="record-detail-items"]',
    content:
      "ນີ້ແມ່ນພາກລາຍການກວດສອບ. ທ່ານຈະເຫັນລາຍການກວດສອບທັງໝົດທີ່ຖືກກວດສອບໃນບັນທຶກ QC ນີ້. ສຳລັບແຕ່ລະລາຍການ, ທ່ານຈະເຫັນຊື່, ຄຳອະທິບາຍ, ສະຖານະ (ຜ່ານ/ບໍ່ຜ່ານ), ຫມາຍເຫດ, ຮູບພາບ (ຖ້າມີ), ແລະວັນທີກວດສອບ. ທ່ານສາມາດກົດເພື່ອເບິ່ງຮູບພາບໃຫຍ່ ຫຼືດາວໂຫຼດຮູບພາບ.",
    placement: "top",
  },
];
